module.exports = __webpack_public_path__ + "images/emoji/cold_sweat.8b3986845df6094e340c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cold_sweat.png
// module id = Mo87
// module chunks = 24